import profileEditSubmitSuccessAlertDictionary from '@widgets/profile-edit-submit-success-alert/i18n//ru/profile-edit-submit-success-alert.dic.json';

export const profileEditSubmitSuccessAlert = {
  PROFILE_EDIT_SUBMIT_SUCCESS_ALERT: profileEditSubmitSuccessAlertDictionary,
};

export const profileEditSubmitSuccessAlertNamespaces = [
  'PROFILE_EDIT_SUBMIT_SUCCESS_ALERT',
];
